//import { Injectable } from "@angular/core";
import { login, LoginService, MqttService, OrmService, PageService } from "jk-service";
import { AgNumberEditor, AgStockQuoteCellView, AgTextAreaEditor, dateFormatter, idNameItem, jkAlert, jkLib, jkRestReturn, jkRestReturnClass, numberFormatter } from "jk-service";
import { ColDef } from "ag-grid-community";
import { AxiosRequestConfig } from "axios";
import { Observable } from "rxjs";
import { inject, Injectable } from "@angular/core";
//import { mqttOptions } from "../../environments/environment";
import { stklg002List, StkMa019List, StkmbService } from "../_service_stk";

export interface PassthroughParam {
  prid: string;
  /** order:下單 | stkpq17:報價 | stkpq18:海期 */
  srvid: 'order' | 'quote' | 'sea';
  caption: string;
  uId?: string;
  date1?: string;
  date2?: string;
  seaAccountList?: string;
  accountList?: string;
  futureAccountList?: string;
  groupId?: string;
  format?: number;
  mode?: number;
  isMinuteSQL?: boolean;
  stockno?: string;
  stocknoStr?: string;
  ProfitLossIndex?: number;
  ProfitLossFormatIndex?: number;
  kLineType?: string;
  tradeSession?: string;
  kLineMinute?: number;
  calcOneDay?: boolean;
  calcSTKMJ?: boolean;

}

export interface ESunConfigFile {
  fileName: string;
  filePath: string;
  content: string;
}

export interface ESunIntradayTickersQuery {
  type: string;
  exchange?: string;
  market?: string;
  industry?: string;
  session?: string;
  product?: string;
  contractType?: string;
  isNormal?: boolean;
  isAttention?: boolean;
  isDisposition?: boolean;
  isHalted?: boolean;
}

export interface ESunHistoricalCandlesQuery {
  // 逗號分隔
  symbolList: string;
  isGroupId: boolean;
  type: string;
  from: string;
  to: string;
  timeframe: string;
}

export class PassthroughService {
  constructor() {
    //console.log('PassthroughService constructor');
  }
}

// kLineMinuteList 0000:即時 0001:1分 0005:5分 0030:30分 0060:60分  日線:日線 月線:月線 周線:周線
//export const kLineMinuteList:idNameItem[] = [{id:'0000',name:'即時'},{id:'0001',name:'1分'},{id:'0005',name:'5分'},{id:'0030',name:'30分'},{id:'0060',name:'60分'},{id:'日線',name:'日線'},{id:'月線',name:'月線'},{id:'周線',name:'周線'}];
// 0:分鐘線,1:(無),2:(無),3:(無),4:日線,5:週線,6:月線
export const kLineTypeList: idNameItem[] = [{ id: '0', name: '分鐘線' }, { id: '4', name: '日線' }, { id: '5', name: '週線' }, { id: '6', name: '月線' }];
//0:全盤K線,1:AM盤K線      (國內期選用)
export const tradeSessionList: idNameItem[] = [{ id: '0', name: '全盤K線' }, { id: '1', name: 'AM盤K線' }];
export let stockQuoteColDefs001: ColDef[] = [
  {
    field: 'stockName',
    headerName: '名稱',
    headerTooltip: '',
    width: 150,
    cellDataType: 'text',
  },
  {
    field: 'time1',
    headerName: '更新時間',
    headerTooltip: '',
    width: 80,
    cellDataType: 'text',
  },
  {
    field: 'close',
    headerName: '收盤',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellRenderer: AgStockQuoteCellView,
  },
  {
    field: 'updown',
    headerName: '漲跌',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellRenderer: AgStockQuoteCellView,
  },
  {
    field: 'updownRate',
    headerName: '漲跌幅',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellRenderer: AgStockQuoteCellView,
  },
  {
    field: 'yClose',
    headerName: '昨收',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellRenderer: AgStockQuoteCellView,
  },
  {
    field: 'open',
    headerName: '開盤',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellRenderer: AgStockQuoteCellView,
  },
  {
    field: 'high',
    headerName: '最高',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellRenderer: AgNumberEditor,
  },
  {
    field: 'low',
    headerName: '最低',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellRenderer: AgNumberEditor,
  },
  {
    field: 'qty',
    headerName: '成交量',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellStyle: { 'text-align': 'right' },
    valueFormatter: numberFormatter,
  },
  {
    field: 'notice',
    headerName: '觀盤重點',
    headerTooltip: '',
    width: 250,
    cellDataType: 'text',
    //cellRenderer: AgTextAreaEditor,
  },
  {
    field: 'summery',
    headerName: '摘要',
    headerTooltip: '',
    width: 250,
    cellDataType: 'text',
    //cellRenderer: AgTextAreaEditor,
  },
  {
    field: 'group',
    headerName: '群組',
    headerTooltip: '',
    width: 250,
    cellDataType: 'text',
    //cellRenderer: AgTextAreaEditor,
  },
  {
    field: 'date1',
    headerName: '更新日期',
    headerTooltip: '',
    width: 120,
    cellDataType: 'text',
    valueFormatter: dateFormatter,
  },
  {
    field: 'stockno',
    headerName: '商品代號',
    headerTooltip: '',
    width: 100,
    cellDataType: 'text',
  },
  //{ field: "TM023", headerName: "啟用",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgCheckBoxEditor,  },
  //{ field: "TM006", headerName: "狀態",headerTooltip: "",width:150,cellDataType: "text", },
];

export let stockQuoteColDefs002: ColDef[] = [
  {
    field: 'stockName',
    headerName: '名稱',
    headerTooltip: '',
    width: 150,
    cellDataType: 'text',
  },
  {
    field: 'time1',
    headerName: '群組更新日期',
    headerTooltip: '',
    width: 100,
    cellDataType: 'text',
  },
  {
    field: 'close',
    headerName: '收盤',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellRenderer: AgStockQuoteCellView,
  },
  {
    field: 'updown',
    headerName: '漲跌',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellRenderer: AgStockQuoteCellView,
  },
  {
    field: 'updownRate',
    headerName: '漲跌幅',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellRenderer: AgStockQuoteCellView,
  },
  {
    field: 'yClose',
    headerName: '昨收',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellRenderer: AgStockQuoteCellView,
  },
  {
    field: 'open',
    headerName: '開盤',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellRenderer: AgStockQuoteCellView,
  },
  {
    field: 'high',
    headerName: '最高',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellRenderer: AgNumberEditor,
  },
  {
    field: 'low',
    headerName: '最低',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellRenderer: AgNumberEditor,
  },
  {
    field: 'qty',
    headerName: '成交量',
    headerTooltip: '',
    width: 72,
    cellDataType: 'number',
    cellStyle: { 'text-align': 'right' },
    valueFormatter: numberFormatter,
  },
  {
    field: 'notice',
    headerName: '觀盤重點',
    headerTooltip: '',
    width: 250,
    cellDataType: 'text',
    cellRenderer: AgTextAreaEditor,
  },
  {
    field: 'summery',
    headerName: '摘要',
    headerTooltip: '',
    width: 250,
    cellDataType: 'text',
    cellRenderer: AgTextAreaEditor,
  },
  {
    field: 'group',
    headerName: '群組',
    headerTooltip: '',
    width: 250,
    cellDataType: 'text',
    cellRenderer: AgTextAreaEditor,
  },
  {
    field: 'date1',
    headerName: '更新日期',
    headerTooltip: '',
    width: 120,
    cellDataType: 'text',
    valueFormatter: dateFormatter,
  },
  {
    field: 'stockno',
    headerName: '商品代號',
    headerTooltip: '',
    width: 100,
    cellDataType: 'text',
  },
  //{ field: "TM023", headerName: "啟用",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgCheckBoxEditor,  },
  //{ field: "TM006", headerName: "狀態",headerTooltip: "",width:150,cellDataType: "text", },
];



export const sendButtonStyle = `.btn-primary-red {
  background-color: red;
  color: white;
}

.btn-primary-green {
  background-color: green;
  color: white;
}
`;

@Injectable({
  providedIn: 'root',
})
export class StockService extends PageService {
  host: string;
  chartTopic: string = 'stock/chart';
  isMQTT: boolean = false;
  isSTKTM: boolean = true;
  stockRange: string = '60'; // 季
  ma001: string[] = [];
  ma019: string[] = []; //  N:上市 Y:上櫃 F:期貨 O:選擇權
  ma026: string[] = []; // 群組A
  ma029: string[] = []; // XQ次標題
  ma056: string = ''; // 價格設定日期
  //orderBy = '1';
  date1: string = '';
  date2: string = jkLib.nowDate();
  stklg002: string = '日線';
  stkma019: idNameItem[] = [];
  topN: number = 121;
  stktmHaveSet: boolean = false;
  isTX25Alert: boolean | null | undefined = true; // 台指期 25點突破/跌破提示音
  stockMessage: string = '';
  lstSize: any;
  _stkme001: string = '000';
  stockName: string = '';
  //isMQTT: boolean = false;
  get stkme001(): string {
    return this._stkme001;
  }
  set stkme001(value: string) {
    this._stkme001 = value;
    this.stkme001Change(value);
  }
  stkmeList: idNameItem[] = []; // TODO:
  _stockNo: string = '';
  get stockNo(): string {
    return this._stockNo;
  }
  set stockNo(value: string) {
    this._stockNo = value;
    let m = this.stkmfList.find((item) => item.id === value);
    if (m) {
      this.stockName = m.name + '(' + m['id'] + ')';
    }
  }
  /*get stockRangeList():idNameItem[] {
    return stockRangeList;
  }*/
  idNameColumnDefs: ColDef[] = [
    { field: "id", headerName: "代號", headerTooltip: "", width: 100, cellDataType: "text", },
    { field: "name", headerName: "名稱", headerTooltip: "", width: 200, cellDataType: "text", },
  ];
  setDate2(value: string) {
    this.date2 = value;
    this.date1 = jkLib.countDate(this.date2, 'D', -120);
  }
  moveStock(step: number): any {
    let idx = this.stkmfList.findIndex((item) => item.id === this.stockNo);
    if (idx >= 0) {
      idx = idx + step;
      if (idx < 0) idx = this.stkmfList.length - 1;
      if (idx >= this.stkmfList.length) idx = 0;
      this.stockNo = this.stkmfList[idx].id;
      return this.stkmfList[idx];
    }
  }
  stkmfList: idNameItem[] = [];
  stkmfListAll: idNameItem[] = [];
  stkma019List: idNameItem[] = StkMa019List;
  jkgridwinVisible: boolean = false;
  stklg002List: idNameItem[] = stklg002List;
  //public mqtt: MqttService = new MqttService();
  _groupId: string = '000';
  get groupId(): string {
    return this._groupId;
  }
  set groupId(value: string) {
    this._groupId = value;
    this.geneGroupStocks(value);
  }
  groupStocks: string = '';
  public orm: OrmService = inject(OrmService);
  public page: PageService = inject(PageService);
  //public login: LoginService;// = inject(LoginService);
  constructor() {
    super();
    this.login = login;
    this.host = this.login.hostName;
    this.date1 = jkLib.countDate(this.date2, 'D', -120);
    // FIXME: 這裡的 mqttOptions['default'] 會報錯 要跑 mqtt 卻跑 ws
    /*
    let bool = this.mqtt.init(
      mqttOptions['default'],
      //'jkStock/' + this.uid,
      ['stock/notify', 'stock/chart', 'stock/quote'],
      this.orm.ip(),
      this.mqttCallback.bind(this)
    );*/

    /*if (!bool) {
      jkAlert('mqtt init error:' + this.mqtt.getResult(), 'error');
    } else {
      this.mqtt.callback = this.mqttCallback.bind(this);
    }*/
    this.lstSize = [
      { id: 2, name: '2' },
      { id: 3, name: '3' },
    ];
    this.loadOpenwin();

  }
  init(isMQTT: boolean, lastDate: string) {
    this.isMQTT = isMQTT;
    //this.uid = uid;
    this.setDate2(lastDate);
    //this.mqtt.callback = this.mqttCallback.bind(this);
  }
  cbQueryStklg?: (message: string) => void;
  cboSetFromMessage?: (message: string) => void;

  mqttCallback(topic: string, message: string) {

    if (this.isMQTT) {
      if (topic === 'stock/chart') {
        //  this.setFromMessage(topic+':'+message);
        if (!message.includes('subscribed')) {
          if (this.cboSetFromMessage)
            this.cboSetFromMessage(message);
          if (this.cbQueryStklg)
            this.cbQueryStklg(message);
        }
      }
    }
  }
  get chartTitle() {
    return this.stkme001 + ' ' + this.stockNo;
  }
  loadOpenwin() {
    try {
      this.orm.doOpenWin_get('S', 'STKME', 'S03', [])
        .subscribe((data: any) => {
          if (data.result) this.stkmeList = data.obj;
          if (this.stkmeList.length > 0) this.stkme001 = this.stkmeList[0].id;
          //this.stkme001Change(this.stkme001);
        });
    } catch (error: any) { }

    //this.stkmfListAll = await jkOpenWin.doOpenWin('S', '#STKMF001', 'S01', []); //
    try {
      //this.stkmfListAll = await jkOpenWin.doOpenWin('W', 'STKMF', 'W01', []); //
      this.orm.doOpenWin_get('S', 'STKMF', 'S01', [])
        .subscribe((data: any) => {
          if (data.result) {
            this.stkmfListAll = data.obj;
            this.stkme001Change(this.stkme001);
          }
        });

    } catch (error: any) {
      jkAlert('STKMF001:' + error.message);
    }
  }
  stkme001Change(value: string) {
    this.stkmfList = this.stkmfListAll.filter(
      (item) => (item as any)['MF001'] === value
    );
    // alert(this.stkmfList.length);
    if (this.stkmfList.length > 0) this.stockNo = this.stkmfList[0].id;
  }
  stockItems: number[] = [];
  stockXAxis: string[] = [];
  getChartItems(stockno: string) {

    //this.stockItems = [];
    //this.stockXAxis = [];
    if (!stockno) return;
    this.orm.doOpenWin_get('S', 'STKLG', 'S01', [stockno]).subscribe((data: any) => {
      if (data.result) {
        for (let item of data.obj) {
          this.stockItems.push(item['close']);
          this.stockXAxis.push(item['FormattedDate']);
        }
      }
    });

  }
  async geneGroupStocks(value: string) {
    let list = this.stkmfListAll.filter(
      (item) => (item as any)['MF001'] === value
    );
    // 將 list 轉換成字串. list[i].id -> a1,a2,a3
    this.groupStocks = list.map((item) => {
      return item.id;
    }).join(',');
  }
  async passThrough(body: any, isSchedule: boolean = false): Promise<jkRestReturn> {
    let ret: jkRestReturn = new jkRestReturnClass();
    if (isSchedule) {
      body.isSchedule = true;

    } else {
      let config: AxiosRequestConfig = jkLib.axiosConfigInit(
        this.host,
        `/stock/kmsai?passThrough=true`,
        'post',
        '',
        body
      );
      let bool = await jkLib.doAxios(config, ret);
    }
    return ret;
  }

  async esunQuotePost(path: string, body: any = {}): Promise<jkRestReturn> {
    const config: AxiosRequestConfig = jkLib.axiosConfigInit(
      this.host,
      `/esun-quote/${path}`,
      'post',
      '',
      body
    );
    const ret: jkRestReturn = new jkRestReturnClass();
    await jkLib.doAxios(config, ret);
    return ret;
  }

  async esunQuoteGet(path: string, urlParam: string = ''): Promise<jkRestReturn> {
    const config: AxiosRequestConfig = jkLib.axiosConfigInit(
      this.host,
      `/esun-quote/${path}?${urlParam}`,
      'get',
      '',
      {}
    );
    const ret: jkRestReturn = new jkRestReturnClass();
    await jkLib.doAxios(config, ret);
    return ret;
  }

  async startFutOptMonitorSchedule(body: any): Promise<jkRestReturn> {
    return this.esunQuotePost('startFutOptMonitorSchedule', body);
  }

  async stopFutOptMonitorSchedule(): Promise<jkRestReturn> {
    return this.esunQuotePost('stopFutOptMonitorSchedule');
  }

  async getFutOptMonitorScheduleStatus(): Promise<jkRestReturn> {
    return this.esunQuoteGet('getFutOptMonitorScheduleStatus');
  }

  async startStockMonitorSchedule(body: any): Promise<jkRestReturn> {
    return this.esunQuotePost('startStockMonitorSchedule', body);
  }

  async stopStockMonitorSchedule(): Promise<jkRestReturn> {
    return this.esunQuotePost('stopStockMonitorSchedule');
  }

  async getStockMonitorScheduleStatus(): Promise<jkRestReturn> {
    return this.esunQuoteGet('getStockMonitorScheduleStatus');
  }

  async getESunConfigFile(fileName: string): Promise<jkRestReturn> {
    return this.esunQuoteGet('getESunConfigFile', `fileName=${encodeURIComponent(fileName)}`);
  }

  async saveESunConfigFile(fileName: string, content: string): Promise<jkRestReturn> {
    return this.esunQuotePost('saveESunConfigFile', { fileName, content });
  }

  async getHistoricalCandles(body: ESunHistoricalCandlesQuery): Promise<jkRestReturn> {
    return this.esunQuotePost('getHistoryCandles', body);
  }

  async getIntradayTickers(query: ESunIntradayTickersQuery): Promise<jkRestReturn> {
    const params = new URLSearchParams();
    params.set('type', query.type);
    if (query.exchange) params.set('exchange', query.exchange);
    if (query.market) params.set('market', query.market);
    if (query.industry) params.set('industry', query.industry);
    if (query.session) params.set('session', query.session);
    if (query.product) params.set('product', query.product);
    if (query.contractType) params.set('contractType', query.contractType);
    if (query.isNormal !== undefined) params.set('isNormal', String(query.isNormal));
    if (query.isAttention !== undefined) params.set('isAttention', String(query.isAttention));
    if (query.isDisposition !== undefined) params.set('isDisposition', String(query.isDisposition));
    if (query.isHalted !== undefined) params.set('isHalted', String(query.isHalted));
    return this.esunQuoteGet('getIntradayTickers', params.toString());
  }

  async kmSaiPost(body: any): Promise<jkRestReturn> {
    //let prid = body.prid;
    // http://localhost:9086/stock/stkmeImportStkmj?date=20240903
    let config: AxiosRequestConfig = jkLib.axiosConfigInit(
      this.host,
      `/stock/kmsai`,
      'post',
      '',
      body
    );
    let ret: jkRestReturn = new jkRestReturnClass();
    let bool = await jkLib.doAxios(config, ret);
    return ret;
  }
  async doAfternoonService(date1: string, stkmbSrv: StkmbService): Promise<jkRestReturn> {
    let accountStr = jkLib.idNameItem2String2(stkmbSrv.accountList);
    let futureAccountStr = jkLib.idNameItem2String2(stkmbSrv.futureAccountList);
    let seaFutureAccountStr = jkLib.idNameItem2String2(stkmbSrv.seaAccountList);
    let uId = stkmbSrv.uId;
    let body = {
      prid: 'doAfternoon',//證期權改價
      srvid: 'quote',
      date: date1,
      uId: uId,
      accountList: accountStr,
      futureAccountList: futureAccountStr,
      seaFutureAccountList: seaFutureAccountStr,
    };
    console.log('doAfternoonService', JSON.stringify(body));
    let ret: jkRestReturn = await this.passThrough(body);
    return ret;
  }
  /**
   * 日結帳
   * @param date1
   * @param stkmbSrv
   * @returns
   */
  async doDayCheckoutService(date1: string, stkmbSrv: StkmbService): Promise<jkRestReturn> {
    let accountStr = jkLib.idNameItem2String2(stkmbSrv.accountList);
    let futureAccountStr = jkLib.idNameItem2String2(stkmbSrv.futureAccountList);
    let seaFutureAccountStr = jkLib.idNameItem2String2(stkmbSrv.seaAccountList);
    let uId = stkmbSrv.uId;
    let body = {
      prid: 'doDayCheckout',
      srvid: 'order',
      date: date1,
      uId: uId,
      /*accountList: accountStr,
      futureAccountList: futureAccountStr,
      seaFutureAccountList: seaFutureAccountStr,*/
    };
    console.log('doDayCheckoutService', JSON.stringify(body));
    let ret: jkRestReturn = await this.passThrough(body);
    return ret;
  }
  calcSTKMJ(group: string, dateA: string, dateB: string, lg002: string, time1: string, mList: string): Observable<any> {
    let url = this.host + `/stock/calcSTKMJ?group=${group}&date1=${dateA}&date2=${dateB}&period=${lg002}&time=${time1}&stkmjList=${mList}`;
    // http://localhost:9086/stock/calcSTKMJ?group=000&date=20240401&period=日線&time=1325&isStkmj=true&isStkmm=false&stocks&stkmjList=C03
    /*this.logMessage += url + '\n';
    orm.http.get(url).subscribe((res) => {
      this.logMessage += JSON.stringify(res) + '\n';
    });*/
    return this.orm.http.get(url);
  }
  async doCalcRangeAll(showResult: boolean, ret: jkRestReturn): Promise<void> {
    let body = {
      caption: '股票日線重計',
      prid: 'calc_range_all',
      date1: this.date1,
      date2: this.date2,
      stocknos: '',
      period: '日線',
      topN: 61,
      isNotify: false,
    };

    let config: AxiosRequestConfig = jkLib.axiosConfigInit(
      this.host,
      `/stock/calc_range_all`,
      'post',
      '',
      body
    );
    //let ret: jkRestReturn = new jkRestReturnClass();
    let bool = await jkLib.doAxios(config, ret);
    if (showResult) {
      if (ret.result) {
        this.page.showToast(body.caption + body.prid + ' 成功');
      } else {
        await this.page.showAlert(
          body.caption +
          '(' +
          body.prid +
          ') 失敗:' +
          ret.message +
          ' ' +
          ret.getResultError()
        );
      }
    }
    //this.logMessage = JSON.stringify(ret);
    return;
  }

}
